function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { normalize } from '@finect/front-utils/normalize';
import { normalizeNO } from '@finect/front-utils/normalizeNO';
import { getAdviserAuthorizationRequests, getAdviserAuthorizationRequestsPending, getAdviserAuthorizationsGranted, setPostAuthorizationStatus, clearPostAuthorizationStatus, getAdviserAuthorizations } from '@finect/front-core/Authorizations';
import { getAuthRequest } from '@finect/front-core/utils';
import { setError } from '../error/actions';
import { sendNotification } from '../../utils/notifications';
import { getMemberConversation } from '../../utils';
import { addNotificationMessages, updateLastMessage, setConversations, setConversation, setConversationsFetchingStatus, addConversationMessages, setConversationMessages, addMessage, replaceMessage, addAdmins, removeAdmins, addMember, removeMembers, removeConversation, updateCurrentLastMessage, updateCurrentTitle, updateMessage, setSelectedConversation, setCurrentView, setCollapsed, setNewConversationMembers, setConversationsSearchResults } from './actions';
var notifySound = function notifySound() {};
export function notifyAll(notifications, next) {
  return function (dispatch) {
    var currentIndex = next || 0;
    var nextIndex = notifications.length - 1 === currentIndex ? null : currentIndex + 1;
    var notification = notifications[currentIndex];
    sendNotification(notification).then(function (notif) {
      if (nextIndex) {
        notif.close();
        dispatch(notifyAll(notifications, nextIndex));
      }
    });
  };
}
export function notifyConversations(conversations, activeConversation) {
  return function (dispatch, getState) {
    var _getState = getState(),
      user = _getState.user;
    var notifyBuffer = [];
    if (conversations) {
      conversations.forEach(function (conversation) {
        var lastMessage = conversation.lastMessage;
        if (activeConversation && activeConversation.id === conversation.id) {
          return;
        }
        if (lastMessage.alias !== user.alias) {
          var notification = {
            title: conversation.title,
            icon: null,
            conversationID: conversation.id,
            message: "Tienes ".concat(conversation.newMessages, " mensajes sin leer.")
          };
          notifyBuffer.push(notification);
        }
      });
    }
    if (activeConversation) {
      var conversationID = activeConversation.id,
        messages = activeConversation.messages,
        authors = activeConversation.authors;
      messages.list.forEach(function (id) {
        var message = messages.items[id];
        if (message.author !== user.id) {
          var author = authors[message.author];
          var notification = {
            title: author.displayName,
            icon: author.icon ? "".concat(process.env.FINECT_URL || '', "/image/").concat(author.icon) : null,
            conversationID: conversationID,
            message: message.body.text
          };
          notifyBuffer.push(notification);
        }
      });
    }
    if (notifyBuffer.length) {
      notifySound();
      dispatch(notifyAll(notifyBuffer));
    }
  };
}
export function updateConversation(conversation) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      conversations = _getState2.conversations;
    var updatedConversation = _objectSpread({}, conversation);
    var storedConversation = conversations.items[conversation.id];
    if (!storedConversation.messages) return null;
    var storedMessageList = new Set(storedConversation.messages.list);
    var nextList = new Set(updatedConversation.messages.list);
    var msgType = ['authorization', 'revoke'];
    var updateAuthMessage = Object.values(updatedConversation.messages.items).filter(function (msg) {
      return msgType.includes(msg.type);
    });
    if (updateAuthMessage) {
      dispatch(getAdviserAuthorizations());
      dispatch(getAdviserAuthorizationRequests());
      dispatch(getAdviserAuthorizationRequestsPending());
      dispatch(getAdviserAuthorizationsGranted());
    }
    updatedConversation.messages.list = _toConsumableArray(new Set(_toConsumableArray(nextList).filter(function (id) {
      return !storedMessageList.has(id);
    })));
    if (updatedConversation.messages.list.length !== 0) {
      dispatch(addNotificationMessages(updatedConversation));
    }
  };
}
export function updateLastMessages(conversations, activeConversationID) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      storedConversations = _getState3.conversations,
      user = _getState3.user;
    var prevItems = storedConversations.items;
    var APIConversations = _toConsumableArray(conversations);
    var newConversations = APIConversations.filter(function (conversation) {
      var storedConversation = prevItems[conversation.id];
      if (storedConversation) {
        var prevLastMessage = storedConversation.lastMessage;
        var nextLastMessage = conversation.lastMessage;
        if (activeConversationID === conversation.id) {
          conversation.newMessages += storedConversation.newMessages;
        }
        if (nextLastMessage.alias === user.alias) {
          conversation.newMessages = 0;
        }
        return !prevLastMessage && nextLastMessage || prevLastMessage.created !== nextLastMessage.created;
      }
      return true;
    });
    if (newConversations.length === 0) return null;
    dispatch(updateLastMessage(newConversations));
  };
}
export function getConversations() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var auth = arguments.length > 1 ? arguments[1] : undefined;
  var group = arguments.length > 2 ? arguments[2] : undefined;
  var authRequest = getAuthRequest(auth);
  var _params$offset = params.offset,
    offset = _params$offset === void 0 ? 0 : _params$offset,
    _params$limit = params.limit,
    limit = _params$limit === void 0 ? 50 : _params$limit,
    _params$orderBy = params.orderBy,
    orderBy = _params$orderBy === void 0 ? '-lastMessage/created' : _params$orderBy,
    _params$filter = params.filter,
    filter = _params$filter === void 0 ? 'active' : _params$filter;
  var request = {
    filter: filter,
    orderBy: orderBy,
    limit: limit,
    offset: offset
  };
  return function (dispatch, getState) {
    dispatch(setConversationsFetchingStatus(true));
    var xGroup = getState().conversations.xGroup;
    var idXGroup = xGroup ? xGroup.id : group ? group.id : null;
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations?filter=".concat(filter, "&limit=").concat(limit, "&offset=").concat(offset, "&orderby=").concat(orderBy),
      method: 'GET',
      headers: _objectSpread(_objectSpread({}, authRequest.headers ? authRequest.headers : {}), idXGroup ? {
        'X-Group': idXGroup
      } : {})
    }, !authRequest.headers ? authRequest : ''), {}, {
      onSuccess: function onSuccess(_ref) {
        var conversations = _ref.data,
          paging = _ref.paging;
        var normConversations = normalize(conversations);
        dispatch(setConversations(normConversations, request, paging));
        dispatch(setConversationsFetchingStatus(false));
      },
      onError: function onError(error) {
        if (error.code === 401) {
          typeof window !== 'undefined' && window.location.assign("".concat(process.env.FINECT_LOGIN || '', "/login?next=").concat(window.location.href));
          return null;
        }
        return dispatch(setError(error));
      }
    }));
  };
}
export function getNextConversations(auth) {
  return function (dispatch, getState) {
    var offset = getState().conversations.list.length;
    var request = _objectSpread(_objectSpread({}, getState().conversations.request), {
      offset: offset
    });
    return dispatch(getConversations(request, auth));
  };
}
export function getConversation(conversationID, cookie) {
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID),
      method: 'GET',
      credentials: cookie
    }, headers), {}, {
      onSuccess: function onSuccess(_ref2) {
        var conversation = _ref2.data;
        var newConversation = _objectSpread({
          newMessages: 0
        }, conversation);
        dispatch(setConversation(newConversation));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function getMessages(conversationID, cursor, cookie) {
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID, "/messages?limit=30").concat(cursor !== null ? "&offset=".concat(cursor) : ''),
      method: 'GET',
      credentials: cookie
    }, headers), {}, {
      onSuccess: function onSuccess(_ref3) {
        var conversation = _ref3.data,
          totalItems = _ref3.paging.totalItems;
        var authors = conversation.authors,
          messages = conversation.messages;
        var normAuthors = normalizeNO(authors);
        var normMessages = normalize(messages);
        var normConversation = {
          id: conversationID,
          authors: normAuthors,
          messages: normMessages,
          totalMessages: totalItems
        };
        cursor !== null ? dispatch(addConversationMessages(normConversation)) : dispatch(setConversationMessages(normConversation));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function getInitialConversation(conversationID, cookie) {
  return function (dispatch) {
    return Promise.all([dispatch(getConversation(conversationID, cookie)), dispatch(getMessages(conversationID, null, cookie))]);
  };
}
export function postMessage(conversationID, message, author, signature) {
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID || '', "/messages"),
      method: 'POST'
    }, headers), {}, {
      body: message,
      onSuccess: function onSuccess(_ref4) {
        var postedMessage = _ref4.data;
        var composedMessage = _objectSpread({}, postedMessage);
        composedMessage.author = author.id;
        composedMessage.created = signature;
        dispatch(replaceMessage(conversationID, composedMessage, author));
        dispatch(updateCurrentLastMessage(conversationID));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function newMessage(message, conversationID, author) {
  return function (dispatch, getState) {
    var signature = new Date().toISOString();
    var xGroup = getState().conversations.xGroup;
    var authorMessage = xGroup ? xGroup : author;
    var syntheticMessage = _objectSpread({
      id: signature,
      created: signature,
      author: authorMessage.id
    }, message);
    var newAuthor = {
      id: authorMessage.id,
      type: 'user',
      alias: authorMessage.alias,
      displayName: authorMessage.displayName ? authorMessage.displayName : authorMessage.alias,
      icon: authorMessage.icon || '',
      links: null
    };
    dispatch(addMessage(conversationID, syntheticMessage, newAuthor)), dispatch(postMessage(conversationID, message, newAuthor, signature));
  };
}
export function newDirectConversation(member, message, cb) {
  var newConversationConfig = {
    user: member,
    message: message
  };
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: 'conversations/direct',
      method: 'POST'
    }, headers), {}, {
      body: newConversationConfig,
      onSuccess: function onSuccess(_ref5) {
        var conversation = _ref5.data;
        dispatch(getConversations());
        cb(conversation);
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function newGroupConversation(members, message, options, cb) {
  var newConversationConfig = {
    type: 'group',
    open: options && options.open || false,
    title: options && options.title || 'Conversación de grupo',
    members: members
  };
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: 'conversations',
      method: 'POST'
    }, headers), {}, {
      body: newConversationConfig,
      onSuccess: function onSuccess(_ref6) {
        var conversation = _ref6.data;
        finectAPI({
          version: 'v4',
          path: "conversations/".concat(conversation.id || '', "/messages"),
          method: 'POST',
          body: message,
          onSuccess: function onSuccess() {
            dispatch(getConversations());
            cb(conversation);
          },
          onError: function onError(error) {
            return dispatch(setError(error));
          }
        });
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function removeMe(conversationID, cb) {
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID, "/members/me"),
      method: 'DELETE'
    }, headers), {}, {
      onSuccess: function onSuccess(_ref7) {
        var conversations = _ref7.data;
        var normConversations = normalize(conversations);
        dispatch(setConversations(normConversations));
        cb();
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function postNewMember(conversationID, memberID) {
  var member = {
    id: memberID,
    isAdmin: false
  };
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID, "/members"),
      method: 'POST'
    }, headers), {}, {
      body: member,
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function addNewMember(conversationID, member) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
      conversations = _getState4.conversations;
    var conversation = conversations.items[conversationID];
    var memberExists = conversation.members.find(function (cMember) {
      return cMember.id === member.id;
    });
    if (!memberExists) dispatch(addMember(conversationID, member));
    dispatch(postNewMember(conversationID, member.id));
  };
}
function postRemoveMembers(conversationID, members) {
  var query = members.join();
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI({
      version: 'v4',
      path: "conversations/".concat(conversationID, "/members?ids=").concat(query),
      method: 'DELETE',
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    });
  };
}
export function deleteMembers(conversationID, members) {
  return function (dispatch) {
    dispatch(removeMembers(conversationID, members));
    dispatch(postRemoveMembers(conversationID, members));
  };
}
function postTitle(conversationID, title) {
  var patch = [{
    op: 'replace',
    path: '/title',
    value: title
  }];
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID),
      method: 'PATCH'
    }, headers), {}, {
      body: patch,
      onSuccess: function onSuccess(_ref8) {
        var conversation = _ref8.data;
        dispatch(setConversation(conversation));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function setTitle(conversationID, title) {
  return function (dispatch) {
    dispatch(updateCurrentTitle(conversationID, title));
    dispatch(postTitle(conversationID, title));
  };
}
export function archive(conversationID, cb) {
  var patch = [{
    op: 'replace',
    path: '/archived',
    value: true
  }];
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID),
      method: 'PATCH'
    }, headers), {}, {
      body: patch,
      onSuccess: function onSuccess() {
        dispatch(removeConversation(conversationID));
        cb();
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function setPrivacy(conversationID, open) {
  var patch = [{
    op: 'replace',
    path: '/open',
    value: open
  }];
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID),
      method: 'PATCH'
    }, headers), {}, {
      body: patch,
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
function postAdmins(conversationID, members, admin) {
  var admins = members.map(function (member) {
    return {
      id: member,
      isAdmin: admin
    };
  });
  var patch = [{
    op: 'replace',
    path: '/members',
    value: admins
  }];
  return function (dispatch, getState) {
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "conversations/".concat(conversationID),
      method: 'PATCH'
    }, headers), {}, {
      body: patch,
      onSuccess: function onSuccess(_ref9) {
        var conversation = _ref9.data;
        dispatch(setConversation(conversation));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}
export function setAdmins(conversationID, members, admin) {
  return function (dispatch) {
    admin ? dispatch(addAdmins(conversationID, members)) : dispatch(removeAdmins(conversationID, members));
    dispatch(postAdmins(conversationID, members, admin));
  };
}
export function postAuthorization(userID, scopes) {
  return function (dispatch) {
    return Promise.all([dispatch(setPostAuthorizationStatus(userID, scopes))]).then(function () {
      finectAPI({
        version: 'v4',
        path: "users/me/authorizations/requests",
        method: 'POST',
        body: {
          user: userID,
          scopes: scopes
        },
        onSuccess: function onSuccess() {
          dispatch(clearPostAuthorizationStatus());
          dispatch(getAdviserAuthorizationRequests());
        },
        onError: function onError(error) {
          dispatch(clearPostAuthorizationStatus());
          if (error.status === 409) {
            return dispatch(setError({
              status: 409,
              customMessage: 'Contacta con el administrador de tu organización para solicitar permisos a este usuario.'
            }));
          }
          return dispatch(setError(error));
        }
      });
    });
  };
}
export function authorize(conversationID, messageID, action) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
      conversations = _getState5.conversations;
    var message = _objectSpread({}, conversations.items[conversationID].messages.items[messageID]);
    var authorizationID = message.body.entity.id;
    message.body.entity.result = {
      accepted: action,
      date: new Date().toISOString()
    };
    return finectAPI({
      version: 'v4',
      path: "users/me/authorizations/requests/".concat(authorizationID, "?action=").concat(action ? 'accept' : 'deny'),
      method: 'PUT',
      body: {},
      onSuccess: function onSuccess() {
        dispatch(updateMessage(conversationID, message));
        dispatch(getAdviserAuthorizationRequestsPending());
        dispatch(getAdviserAuthorizationsGranted());
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    });
  };
}
export function openConversation(conversationId) {
  return function (dispatch) {
    return Promise.all([dispatch(setSelectedConversation(conversationId)), dispatch(setCurrentView('conversation')), dispatch(setCollapsed(false))]);
  };
}
export function newMessageToMembers(membersIds) {
  return function (dispatch, getState) {
    var _membersIds = _slicedToArray(membersIds, 1),
      memberId = _membersIds[0];
    if (!memberId) return;
    return Promise.resolve(dispatch(getConversations())).then(function () {
      var conversation = getMemberConversation(getState().conversations.items, memberId);
      if (conversation) {
        return dispatch(openConversation(conversation.id));
      }
      return Promise.all([dispatch(setNewConversationMembers(membersIds)), dispatch(setCurrentView('newConversation')), dispatch(setCollapsed(false))]);
    });
  };
}
export function getSearch(search) {
  return function (dispatch, getState) {
    if (!search) {
      return Promise.resolve(dispatch(setConversationsSearchResults([])));
    }
    var xGroup = getState().conversations.xGroup;
    var headers = xGroup ? {
      headers: {
        'X-Group': xGroup.id
      }
    } : {};
    return finectAPI(_objectSpread(_objectSpread({
      version: 'v4',
      path: "search/conversations?q=".concat(search),
      method: 'GET'
    }, headers), {}, {
      onSuccess: function onSuccess(_ref10) {
        var data = _ref10.data;
        dispatch(setConversationsSearchResults(data));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    }));
  };
}